import React, {useEffect, useState} from "react";
import AppColors from './../colors/AppColors';
import {useWindowSize} from "react-use";
import AppIcon from "../views/AppIcon";
import axios from "axios";

import {
    Button,
    Card,
    CardContent,
    Checkbox,
    CircularProgress,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextField,
    Typography,
    useMediaQuery
} from "@material-ui/core";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Strings from './../lang/Strings';
import {useOnBoarderStyle} from '../styles/OnBoarderSlideStyles';
import {Link, Redirect} from "react-router-dom";
import Routes from './../constants/Routes';
import {useWelcomeStyle} from '../styles/WelcomeStyle';
import {useTheme} from '@material-ui/core/styles';
import {grey} from '@material-ui/core/colors';
import MaterialSnackBar from "../views/MaterialSnackBar";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {SignUpState} from "../enums/AuthState";
import {Validator} from "../utils/Validator";
import {useCookies} from "react-cookie";
import EndPoints from "../net/EndPoints";
import UsersManager from "../managers/UsersManager";
import {Constants} from "../constants/Constants";
import {useDispatch} from "react-redux";
import PageUtils from "../utils/PageUtils";

export default function SignUpView() {

    const onBoarderClasses = useOnBoarderStyle();
    const welcomeClasses = useWelcomeStyle();
    const {width, height} = useWindowSize();
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down(800));
    const [doneWithSignUp, setDoneWithSignUp] = useState(false);
    const [signUpState, setSignUpState] = useState(SignUpState.IDLE);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [referer, setReferer] = useState("");
    const [username, setUserName] = useState<string | null>("");
    const [email, setEmail] = useState<string | null>("");
    const [password, setPassword] = useState<string | null>("");
    const [repeatPassword, setRepeatPassword] = useState<string | null>("");

    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("warning");
    const [licenseAccepted, setLicenseAccepted] = useState(false);
    const [cookies, _] = useCookies(['name']);
    const dispatch = useDispatch();

    useEffect(() => {
        let possibleReferer = PageUtils.getPageParams(window.location.href.toString())[Constants.REFERER];
        if (possibleReferer !== undefined) {
            setReferer(possibleReferer);
        }
    }, [window.location.href]);

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const handleLicenseAction = () => {
        setLicenseAccepted(!licenseAccepted);
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleClickShowRepeatPassword = () => {
        setShowRepeatPassword(!showRepeatPassword);
    }

    const handleUserNameChange = (newValue: string | null) => {
        setUserName(newValue);
    }

    const handleEmailChange = (newValue: string | null) => {
        setEmail(newValue);
    }

    const handlePasswordChange = (newValue: string | null) => {
        setPassword(newValue);
    }

    const handleRepeatPasswordChange = (newValue: string | null) => {
        setRepeatPassword(newValue);
    }

    const handleKeyEvent = (event: KeyboardEvent) => {
        if (event.keyCode === 13) {
            signUpUser();
        }
    }

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    }

    const snackError = (message: string) => {
        setSnackMessage(message);
        setSnackSeverity("error");
        setOpenSnack(true);
    }

    const signUpUser = () => {
        if (email?.length !== 0 && password?.length !== 0 && repeatPassword?.length !== 0 && username?.length !== 0 && licenseAccepted) {
            if (Validator.isEmailValid(email as string)) {
                if (password === repeatPassword) {
                    setSignUpState(SignUpState.STARTED);
                    let signUpData = {
                        username: username as string,
                        email: email as string,
                        password: password as string,
                        referer: referer
                    };
                    axios.post(EndPoints.SIGN_UP, signUpData).then(response => {
                        let userData = response["data"]["data"];
                        userData[Constants.REMEMBER_ME] = true;
                        UsersManager.saveLoggedInUser(JSON.stringify(userData));
                        dispatch({
                            type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                            payload: JSON.stringify(userData)
                        })
                        setDoneWithSignUp(true);
                    }).catch(error => {
                        let errorResponseData = error.response["data"]
                        let message = errorResponseData["message"] ?? "Error completing sign up. Please try again";
                        setSignUpState(SignUpState.IDLE);
                        snackError(message);
                    });
                } else {
                    snackError("Sorry,passwords didn't match");
                }
            } else {
                snackError("Invalid email provided");
            }
        } else {
            snackError("Please provide all necessary fields and accept our Terms and Conditions");
        }
    }

    return (
        doneWithSignUp ?
            <Redirect to={Routes.HOME}/> :
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: `url(${require('./../images/wallet_background.png')})`,
                    backgroundColor: '#121d33e1',
                    backgroundRepeat: 'none',
                    backgroundSize: 'cover'
                }}>
                <AppBar position="static"
                        elevation={0}
                        style={{
                            background: 'none'
                        }}>
                    <Toolbar>
                        <AppIcon/>
                    </Toolbar>
                </AppBar>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: height
                }}>
                    <Card
                        style={{
                            width: mobileView ? width - 30 : width / 2,
                            borderRadius: 10,
                        }}>
                        <CardContent
                            style={{
                                margin: 25,
                            }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                <Typography
                                    style={{
                                        fontWeight: 600,
                                        alignSelf: 'flex-start',
                                        fontSize: 20
                                    }}>Get OnBoard!</Typography>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="username"
                                    label="Username"
                                    name="username"
                                    required
                                    value={username}
                                    disabled={signUpState === SignUpState.STARTED}
                                    autoComplete="username"
                                    onChange={(event) => {
                                        handleUserNameChange(event.target.value)
                                    }}
                                    onKeyDown={(event) => {
                                        handleKeyEvent(event as unknown as KeyboardEvent)
                                    }}
                                    className={welcomeClasses.fullScreenAuthFields}
                                    style={{
                                        fontWeight: 600,
                                    }}
                                />
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    required
                                    value={email}
                                    disabled={signUpState === SignUpState.STARTED}
                                    autoComplete="email"
                                    onChange={(event) => {
                                        handleEmailChange(event.target.value)
                                    }}
                                    onKeyDown={(event) => {
                                        handleKeyEvent(event as unknown as KeyboardEvent)
                                    }}
                                    className={welcomeClasses.fullScreenAuthFields}
                                    style={{
                                        fontWeight: 600,
                                    }}
                                />
                                <Typography style={{
                                    color: grey[400],
                                    fontSize: 12,
                                    alignSelf: 'flex-start',
                                    fontWeight: 400,
                                }}>*Email would be verified</Typography>
                                <FormControl
                                    margin="normal"
                                    fullWidth
                                    disabled={signUpState === SignUpState.STARTED}
                                    classes={{root: welcomeClasses.fullScreenAuthFields}}
                                    variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                    <OutlinedInput
                                        autoComplete="current-password"
                                        id="outlined-adornment-password"
                                        name="password"
                                        required
                                        disabled={signUpState === SignUpState.STARTED}
                                        type={showPassword ? 'text' : 'password'}
                                        value={password}
                                        onChange={(event) => {
                                            handlePasswordChange(event.target.value)
                                        }}
                                        onKeyDown={(event) => {
                                            handleKeyEvent(event as unknown as KeyboardEvent)
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    tabIndex="-1"
                                                    style={{
                                                        color: AppColors.BLACK
                                                    }}
                                                    disableFocusRipple
                                                >{showPassword ? <Visibility fontSize={"small"}/> :
                                                    <VisibilityOff fontSize={"small"}/>}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={70}
                                    />
                                </FormControl>
                                <Typography style={{
                                    color: grey[400],
                                    fontSize: 12,
                                    alignSelf: 'flex-start',
                                    fontWeight: 400,
                                }}>*Please use a very strong password</Typography>
                                <FormControl
                                    margin="normal"
                                    fullWidth
                                    disabled={signUpState === SignUpState.STARTED}
                                    classes={{root: welcomeClasses.fullScreenAuthFields}}
                                    variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-password-repeat">Password</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password-repeat"
                                        name="repeat-password"
                                        label="Repeat Password"
                                        required
                                        disabled={signUpState === SignUpState.STARTED}
                                        type={showRepeatPassword ? 'text' : 'password'}
                                        value={repeatPassword}
                                        onChange={(event) => {
                                            handleRepeatPasswordChange(event.target.value)
                                        }}
                                        onKeyDown={(event) => {
                                            handleKeyEvent(event as unknown as KeyboardEvent)
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowRepeatPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    tabIndex="-1"
                                                    style={{
                                                        color: AppColors.BLACK
                                                    }}
                                                    disableFocusRipple
                                                >{showRepeatPassword ? <Visibility fontSize={"small"}/> :
                                                    <VisibilityOff fontSize={"small"}/>}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={70}
                                    />
                                </FormControl>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <Checkbox onChange={handleLicenseAction}
                                              className={onBoarderClasses.rememberMeCheckStyle}/>
                                    <Typography style={{}}
                                                dangerouslySetInnerHTML={{__html: `<span style='font-size:12px;text-align:center;'>By creating an account, you agree to our <a href=${Routes.TERMS_AND_CONDITIONS} style='color:${AppColors.ACCENT_COLOR}'>Terms and Conditions</a></span>`}}/>
                                </div>
                                <Button
                                    disabled={email?.length === 0 || password?.length === 0 || repeatPassword?.length === 0 || signUpState === SignUpState.STARTED || !licenseAccepted}
                                    onClick={signUpUser}
                                    className={mobileView ? onBoarderClasses.getStartedButtonSmall : onBoarderClasses.getStartedButton}
                                    style={{
                                        width: '100%',
                                        marginTop: 20,
                                        marginBottom:5,
                                        fontSize: mobileView ? 13 : 20,
                                    }}>{signUpState === SignUpState.STARTED ? Strings.PLEASE_WAIT : Strings.CREATE_ACCOUNT}
                                    {
                                        signUpState === SignUpState.STARTED &&
                                        <CircularProgress color="inherit" size={20}
                                                          style={{
                                                              marginLeft: 10,
                                                              color: AppColors.ACCENT_COLOR
                                                          }}/>
                                    }
                                </Button>

                            </div>
                        </CardContent>
                    </Card>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginTop: 10,
                        marginBottom: 20,
                    }}>
                        <Typography style={{
                            color: AppColors.GREY_TEXT,
                            fontWeight: 600,
                            fontSize: 15,
                        }}>Already have an account?</Typography>
                        <Link to={Routes.LOGIN}
                              style={{
                                  color: AppColors.WHITE,
                                  fontWeight: 600,
                                  marginLeft: 5,
                                  fontSize: 14,
                                  textDecoration: 'none'
                              }}>{Strings.LOGIN_TEXT}
                        </Link>
                    </div>
                </div>
                <MaterialSnackBar open={openSnack} onSnackClosed={handleSnackClose} message={snackMessage}
                                  severity={snackSeverity}/>
            </div>
    );
}